import React, { useRef } from "react";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";

const s3 = new S3Client({
  region: "ap-south-1",
  credentials: {
    accessKeyId: "AKIA2NIWIBYODQQMOVAK",
    secretAccessKey: "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",
  },
  requestChecksumCalculation: "WHEN_REQUIRED",
});

export default function ImageUpload({
  images = [],
  setImages,
  title = "Upload Images",
  multiple = true,
}) {

  const fileInputRef = useRef();

  const uploadImageToS3 = async (file) => {
    const cleanName = file.name.replace(/\s/g, "_");
    const fileName = `uploads/${Date.now()}_${cleanName}`;

    const buffer = await file.arrayBuffer();

    await s3.send(
      new PutObjectCommand({
        Bucket: "kokaki-images",
        Key: fileName,
        Body: buffer,
        ContentType: file.type,
        ACL: "public-read",
      })
    );

    return `https://kokaki-images.s3.ap-south-1.amazonaws.com/${fileName}`;
  };

  const handleChange = (e) => {
    const files = Array.from(e.target.files);

    // allow selecting same file again
    e.target.value = null;

    files.forEach(async (file) => {
      const id = Date.now() + Math.random();

      const preview = URL.createObjectURL(file);

      // ✅ Step 1: add immediately
      const newImage = {
        id,
        preview,
        url: null,
      };

      setImages((prev) => [...prev, newImage]);

      try {
        // ✅ Step 2: upload (background)
        const url = await uploadImageToS3(file);

        // ✅ Step 3: update ONLY url
        setImages((prev) =>
          prev.map((img) =>
            img.id === id ? { ...img, url } : img
          )
        );

      } catch (err) {
        console.error("Upload failed:", err);
      }
    });
  };

  // ✅ Remove image
  const removeImage = (id) => {
    setImages((prev) => {
      const img = prev.find((i) => i.id === id);

      if (img?.preview) {
        URL.revokeObjectURL(img.preview);
      }

      return prev.filter((i) => i.id !== id);
    });
  };

  return (
    <div className="mb-12">
      <h2 className="text-lg font-medium mb-6">{title}</h2>

      <div className="flex flex-wrap gap-6 items-start">

        {images.map((image) => (
          <div key={image.id} className="relative group">
            <img
              src={image.preview} // ✅ ALWAYS preview (never breaks)
              alt="Preview"
              className="w-40 h-28 object-cover border border-neutral-200"
            />

            <button
              type="button"
              onClick={() => removeImage(image.id)}
              className="absolute top-1 right-1 bg-black bg-opacity-50 text-white w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100"
            >
              ×
            </button>
          </div>
        ))}

        <label className="w-28 h-28 border border-dashed border-neutral-300 flex items-center justify-center cursor-pointer text-sm text-gray-500">
          + Upload

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            multiple={multiple}
            className="hidden"
            onChange={handleChange}
          />
        </label>

      </div>
    </div>
  );
}